import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { NavbarContainerProps, NavbarItemProps } from './types';

export const LkNavbarContainerUI = styled.div<NavbarContainerProps>`
  height: 100%;
  width: ${(props) => (props.collapsed ? '350px' : '100px')};
  background: #1272ba;
  transition: width 0.6s;
  z-index: 15;
  position: fixed;
`;

export const NavbarItems = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const NavbarItem = styled.div<NavbarItemProps>`
  width: 100%;
  height: ${(props) => (props.logo ? '80px' : '55px')};

  background: ${(prop) => (prop.logo ? '#1064A3' : prop.active ? '#34A7FF' : '#1272ba')};
  cursor: pointer;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: ${(props) => (props.logo ? '0 30px' : '0 36px')};
  flex-direction: row;
  flex-wrap: nowrap;
  gap: ${(props) => (props.logo ? '30px' : '36px')};
  overflow: hidden;

  .logo-layout {
    display: ${(props) => (props.collapsed ? 'flex' : 'flex')};
    align-items: center;
    justify-content: center;
    color: white;

    h2 {
      width: 250px;
      font-size: 18px;
      font-weight: 600;
      line-height: 21px;
      color: white;
      text-transform: uppercase;
      margin: 0;
    }
  }

  .layout {
    font-size: 18px;
    line-height: 21px;
    color: white;
    font-weight: 400;
  }

  .svg-container {
    width: 30px;
    height: 30px;

    justify-content: center;
    align-items: center;
    svg {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  svg {
    width: 30px;
    font-size: 200px;
    height: 30px;
  }
  img {
    width: ${(props) => (props.logo ? '40px' : '30px')};
  }

  &:hover {
    background: ${(props) => (props.logo ? '#1064A3' : '#34A7FF')};
  }
`;

export const CollapseItem = styled.div`
  width: 100%;
  height: 50px;

  svg {
    fill: white;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  background: #1272ba;
  cursor: pointer;

  user-select: none;

  font-size: 30px;
  color: white;
  font-weight: 300;

  &:hover {
    background: #2989d1;
  }
`;

export const NavbarLink = styled(Link)`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  gap: 36px;
  overflow: hidden;
`;

export const ScreenDarker = styled.div`
  width: 100vw;
  height: 100vh;

  position: fixed;
  left: 0;

  background: rgba(0, 0, 0, 0.3);
  transition: opacity 0.6s;
  z-index: 2;
`;
